import { Frustum, Matrix4, Object3D, PerspectiveCamera, Vector3 } from "three";

const TMP = new Vector3();
const TMP_2 = new Vector3();
const TMP_3 = new Vector3();

class ScreenSpacePosition {
  private parent: Object3D;
  private camera: PerspectiveCamera;
  private worldPositionVector = new Vector3();
  private frustum = new Frustum();
  private projScreenMatrix = new Matrix4();
  private offset?: Vector3;

  constructor(parent: Object3D, camera: PerspectiveCamera, offset?: Vector3) {
    this.parent = parent;
    this.camera = camera;
    this.offset = offset;
  }

  public get inFrustum(): boolean {
    this.camera.updateMatrix(); // make sure camera's local matrix is updated
    this.camera.updateMatrixWorld(); // make sure camera's world matrix is updated

    const worldPosition = this.parent.getWorldPosition(
      this.worldPositionVector
    );
    if (this.offset) {
      worldPosition.add(this.offset);
    }
    this.projScreenMatrix.multiplyMatrices(
      this.camera.projectionMatrix,
      this.camera.matrixWorldInverse
    );
    this.frustum.setFromProjectionMatrix(this.projScreenMatrix);
    return this.frustum.containsPoint(worldPosition);
  }

  public get position(): Vector3 {
    const worldPosition = this.parent.getWorldPosition(
      this.worldPositionVector
    );
    if (this.offset) {
      worldPosition.y += this.offset.y;

      if (this.offset.x !== 0 || this.offset.y !== 0) {
        TMP_3.copy(this.offset);
        TMP_3.y = 0;
        const length = TMP_3.length();
        TMP_3.y = 1;

        const worldToCamera = TMP.copy(worldPosition).sub(this.camera.position);
        worldToCamera.y = 0;
        worldToCamera.normalize();

        TMP_2.crossVectors(TMP_3.normalize(), worldToCamera).multiplyScalar(
          length
        );
        TMP_2.y = 0;

        worldPosition.sub(TMP_2);
      }
    }
    worldPosition.project(this.camera);
    worldPosition.x = ((worldPosition.x + 1) / 2) * window.innerWidth;
    worldPosition.y = (-(worldPosition.y - 1) / 2) * window.innerHeight;
    return worldPosition;
  }

  public get distance(): number {
    const worldPosition = this.parent.getWorldPosition(
      this.worldPositionVector
    );
    if (this.offset) {
      worldPosition.add(this.offset);
    }
    return worldPosition.distanceTo(this.camera.position);
  }
}

export default ScreenSpacePosition;
